import React, { useState, useEffect } from 'react';
import { Form } from 'antd';
import { Captcha } from 'gyyx-component-lib';
import { ValidData } from 'gyyx-component-lib/es/interface';
import { useOutletContext } from 'react-router-dom';
import BaseForm from '@/components/BaseForm';
import KfLayout from '@/components/KfLayout';
import Nav from '@/components/Nav';
import { K_F_BID, RESPONSE_STATUS } from '@/constants';
import { submitQiBaoRecovered } from '@/services/kf';
import { LoginInfo, IServerVal } from '@/types';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';
import Confirm from '@/components/Confirm';
import SuccessModal from '../successModal';
import './index.less';

const QiBaoItemsRecovered = () => {
    const [visible, setVisible] = useState(false);
    const [successStatus, setSuccessStatus] = useState(false);
    const [errorTips, setErrorTips] = useState('');
    const [form] = Form.useForm();
    const loginInfo = useOutletContext() as LoginInfo;
    const setUpdateLogin = useSetAtom(loginAtom);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!loginInfo?.isLogin) {
            setUpdateLogin({isLogin: false, visibleLogin: true});
        }
    }, [loginInfo?.isLogin]);
    


    const getConditions = () => {
        return [
            {
                label: <>被问账号<span className="custom_required">*</span></>,
                type: 'TEXT',
                name: 'askAccount',
                key: 'askAccount',
                render: () => <div>{loginInfo.account}</div>,
                itemOptions: {
                    colon: false
                }
            },
            {
                label: <>游戏<span className="custom_required">*</span></>,
                type: 'SELECT',
                name: 'gameId',
                key: 'gameId',
                options: {
                    placeholder: '请选择',
                    options: [
                        {
                            label: '问道',
                            value: 2
                        }
                    ]
                },
                rules: [
                    {
                        required: true,
                        message: '必填',
                    }
                ],
                itemOptions: {
                    colon: false
                }
            },
            {
                label: <>服务器<span className="custom_required">*</span></>,
                type: 'GAME_SERVER',
                name: 'serverId',
                key: 'serverId',
                options: {
                    serIptClassName: 'sever_input',
                    serSelClassName: 'sever_sel_btn',
                    status: 'activation',
                    isWeGame: true,
                    gameId: 2,
                    setValueFn: (item: IServerVal) => {
                        form.setFieldsValue({ serverId: item.code });
                    }
                },
                rules: [
                    {
                        required: true,
                        message: '必填',
                    }
                ],
                itemOptions: {
                    colon: false
                }
            },
            {
                label: <>角色名称<span className="custom_required">*</span></>,
                type: 'INPUT',
                name: 'role',
                key: 'role',
                rules: [
                    {
                        required: true,
                        message: '必填',
                    },
                    {
                        whitespace: true,
                        message: '必填'
                    }
                ],
                itemOptions: {
                    colon: false
                },
                options: {
                    maxLength: 30
                }
            },
            {
                label: <>被盗时间<span className="custom_required">*</span></>,
                type: 'DATE',
                name: 'stolenTime',
                key: 'stolenTime',
                rules: [
                    {
                        required: true,
                        message: '必填',
                    }
                ],
                itemOptions: {
                    colon: false
                },
                options: {
                    disabledDate: (currentDate: any) => {
                        const now = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 3600000 - 1).valueOf();
                        return currentDate.valueOf() < now - 16 * 24 * 3600000 || currentDate.valueOf() > now
                    }
                }
            },
            {
                label: <>被盗情况和被盗物品信息<span className="custom_required">*</span></>,
                type: 'TEXTAREA',
                name: 'stolenItemInfo',
                key: 'stolenItemInfo',
                options: {
                    autoSize: { minRows: 6, maxRows: 6 },
                    style: { width: '400px' },
                    maxLength: 200,
                    placeholder: '注: 请务必在此栏填写具体被盗经过的详细情况及被盗物品信息。'
                },
                itemOptions: {
                    className: 'form_item_textarea',
                    colon: false
                },
                rules: [
                    {
                        required: true,
                        message: '必填'
                    },
                    {
                        whitespace: true,
                        message: '必填'
                    }
                ]
            },
            {
                label: <>奇宝斋被盗物品编号<span className="custom_required">*</span></>,
                type: 'TEXTAREA',
                name: 'stolenItemCode',
                key: 'stolenItemCode',
                itemOptions: {
                    className: 'form_item_textarea',
                    colon: false
                },
                options: {
                    autoSize: { minRows: 6, maxRows: 6 },
                    style: { width: '400px' },
                    maxLength: 200,
                    placeholder: '请务必填写正确的物品编号，如填写错误则无法核实，为了避免耽误您的问题，请谨慎填写。'
                },
                rules: [
                    {
                        required: true,
                        message: '必填'
                    },
                    {
                        whitespace: true,
                        message: '必填'
                    }
                ]
            }
        ];
    }

    const submitCaptch = async (data: ValidData) => {
        setVisible(false);
        const { captcha, cookies, balanceCode } = data;
        const values = form.getFieldsValue();
        values.stolenTime = values.stolenTime.format('YYYY-MM-DD');
        const params = {
            ...values,
            captcha,
            cookies,
            balanceCode,
            bid: K_F_BID
        }
        const res = await submitQiBaoRecovered(params);
        if (res.retCode === RESPONSE_STATUS.SUCCESS) {
            setSuccessStatus(true);
        } else {
            if (res.data?.error === 'NoLoginError') {
                setUpdateLogin?.({ isLogin: false, visibleLogin: true });
            } else {
                setErrorTips(res.message);
                setOpen(true)
            }
        }
    }

    const onFinish = () => {
        if (!loginInfo?.isLogin) {
            setUpdateLogin?.({ isLogin: false, visibleLogin: true });
            return;
        }
        form.validateFields().then(() => {
            setVisible(true);
        }).catch((error) => {
            console.log(error);
        });
    }

    const onReset = () => {
        form.resetFields();
    }

    return (
        <div className="qibao_items_recovered">
            <Nav activeMenu="kfCenter" />
            <KfLayout title="奇宝斋物品交易申诉">
                {successStatus ?
                    <SuccessModal title="创建成功">
                        <div>您的问题已经收到，请耐心等待回复。</div>
                    </SuccessModal> :
                    <div>
                        <BaseForm form={form} conditions={getConditions()} onFinish={onFinish} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} />
                        <div className="reminder">
                            特别提示：<br/>
                            ①找回可预订商品时，需要承担买家操作消耗的一切费用，另还额外需要补偿买家物品总金额的10%，最低为1000万游戏币。（以服务器中奇宝斋价格为参考标准）<br/>
                            ②找回后的所有商品均为解除绑定状态无法立即交易。<br/>
                            ③宠物、法宝等不会保留亲密度。
                        </div>
                        <div className="btn_group">
                            <div className="submit btn" onClick={onFinish}>确认</div>
                            <div className="reset btn" onClick={onReset}>清空</div>
                        </div>
                    </div>
                }
            </KfLayout>
            <Captcha
                visible={visible}
                bId={K_F_BID}
                onSubmit={submitCaptch}
                onClose={() => setVisible(false)}
            />
            <Confirm isClose={false} message={errorTips} open={open} onOk={() => setOpen(false)}/>
        </div>
    )
}

export default QiBaoItemsRecovered;